import React, {createContext,useContext,useCallback, useMemo, useReducer} from 'react';

const ADDRESS = 'ADDRESS'
const NETWORK = 'NETWORK'
const ROUTE_ROADMAP = 'ROUTE_ROADMAP'
const SHOW_VIDEO = 'SHOW_VIDEO'

const Context = createContext()

function useAccountContext() {
  return useContext(Context)
}

const initState = {
  address: null,
  network: null,
  routeRoadmap: false,
  showVideo: true
}

function reducer(state, {type, payload}) {
  switch (type) {
    case ADDRESS: {
      const {address} = payload
      return {
        ...state,
        address: address,
      }
    }
    case NETWORK: {
      const {network} = payload
      return {
        ...state,
        network: network,
      }
    }
    case ROUTE_ROADMAP: {
      const {routeRoadmap} = payload
      return {
        ...state,
        routeRoadmap: routeRoadmap,
      }
    }
    case SHOW_VIDEO: {
      const {showVideo} = payload
      return {
        ...state,
        showVideo: showVideo,
      }
    }
    default: {
      throw Error(`Unexpected action type in DataContext reducer: '${type}'.`)
    }
  }
}
export default function Provider({children}) {
  const [state, dispatch] = useReducer(reducer, initState)

  const updateAddress = useCallback((address) => {
    dispatch({
      type: ADDRESS,
      payload: {
        address,
      }
    })
  },[])

  const updateNetwork = useCallback((network) => {
    dispatch({
      type: NETWORK,
      payload: {
        network,
      }
    })
  },[])

  const updateRouteRoadmap = useCallback((routeRoadmap) => {
    dispatch({
      type: ROUTE_ROADMAP,
      payload: {
        routeRoadmap,
      }
    })
  },[])

  const updateShowVideo = useCallback((showVideo) => {
    dispatch({
      type: SHOW_VIDEO,
      payload: {
        showVideo,
      }
    })
  },[])

  return (
    <Context.Provider
      value={useMemo(() => [
        state, {
        updateAddress,
        updateNetwork,
        updateRouteRoadmap,
        updateShowVideo
      }],[
        state,
        updateAddress,
        updateNetwork,
        updateRouteRoadmap,
        updateShowVideo
      ])}
    >
      {children}
    </Context.Provider>
  )
}

export function useAddress() {
  const [state, {updateAddress}] = useAccountContext()
  return [state.address, updateAddress]
}

export function useNetwork() {
  const [state, {updateNetwork}] = useAccountContext()
  return [state.network, updateNetwork]
}

export function useRouteRoadmap() {
  const [state, {updateRouteRoadmap}] = useAccountContext()
  return [state.routeRoadmap, updateRouteRoadmap]
}

export function useShowVideo() {
  const [state, {updateShowVideo}] = useAccountContext()
  return [state.showVideo, updateShowVideo]
}